// extracted by mini-css-extract-plugin
export default {"wrapper":"landing__wrapper__R1247 universalHubApp__page__iW4E5"};